import React from "react";
import FileCard from "./FileCard";
import NoFiles from "../EmptyList/NoFiles";

const Filelist = ({
  data = [],
  folderClick,
  filePreview,
  handleMove,
  handleRename,
  handleDelete,
  changeFav,
  selectedKeys = [],
  setSelectedKeys,
  isFav= false,
  handleRestore,
  isBin = false
}) => {
  return (
    <>
      {data?.length === 0 ? (
        <NoFiles />
      ) : (
        <>
          {data?.map((item) => (
            <FileCard
              handleMove={handleMove}
              handleRename={handleRename}
              handleDelete={handleDelete}
              changeFav={changeFav}
              handleRestore={handleRestore}
              onClick={item?.item_type === "folder" ? folderClick : filePreview}
              key={item?.id}
              details={item}
              selectedKeys={selectedKeys}
              setSelectedKeys={setSelectedKeys}
              isFav={isFav}
              isBin={isBin}
            />
          ))}
        </>
      )}
    </>
  );
};

export default Filelist;
